// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__Ip214","popup":"Footer_popup__yKrlO","menu":"Footer_menu__ZD5CL","fadeIn":"Footer_fadeIn__jZI5J","spin":"Footer_spin__ABM0A"};